import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import MobileCTA from '../../components/feature/MobileCTA';

const HomePage = () => {
  const services = [
    {
      icon: 'ri-paint-brush-line',
      title: 'Interior Painting',
      description: "Fresh paint for your rooms, hallways, and ceilings. We prep walls, protect your floors and furniture, and clean up when we're done.",
    },
    {
      icon: 'ri-home-4-line',
      title: 'Exterior Painting',
      description: 'Keep your home looking good and protected from Michigan weather. We paint siding, trim, doors, and more.',
    },
    {
      icon: 'ri-door-line',
      title: 'Cabinet Painting',
      description: 'Update your kitchen or bathroom without replacing everything. Cabinet painting gives you a fresh look for less.',
    },
    {
      icon: 'ri-layout-grid-line',
      title: 'Fence Staining',
      description: 'Protect your wood fence and keep it looking good. Staining helps it last longer and look better.',
    },
    {
      icon: 'ri-stack-line',
      title: 'Deck Staining',
      description: 'Keep your deck protected from sun, rain, and snow. Regular staining helps prevent cracking and fading.',
    },
    {
      icon: 'ri-palette-line',
      title: 'Color Help',
      description: "Not sure what color to pick? We can help you choose colors that look good and match your home.",
    },
  ];

  const serviceAreas = ['Kalamazoo', 'Portage', 'Plainwell', 'Three Rivers', 'Otsego', 'Nearby Areas'];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <MobileCTA />

      {/* Hero Section */}
      <section className="pt-20 min-h-screen flex items-center">
        <div className="w-full">
          <div className="max-w-[1400px] mx-auto">
            <div className="grid lg:grid-cols-[60%_40%] min-h-[calc(100vh-80px)]">
              <div className="flex items-center px-6 lg:px-16 py-12 lg:py-0 bg-[#F3F1EE]">
                <div className="max-w-[580px]">
                  <div className="flex items-center gap-3 mb-5">
                    <div className="inline-block bg-[#10B981] text-white px-4 py-1.5 rounded-full text-[12px] font-bold uppercase tracking-wider">
                      Hablamos Español
                    </div>
                    <span className="text-[13px] text-[#6B7280] font-medium">Kalamazoo &amp; Southwest Michigan</span>
                  </div>
                  <h1 className="text-[46px] lg:text-[54px] leading-[1.08] font-extrabold text-[#1A2B4A] mb-5">
                    Quality Painting<br />
                    <span className="text-[#C8A96E]">for Your Home</span>
                  </h1>
                  <p className="text-[17px] text-[#6B7280] leading-relaxed mb-8 max-w-[500px]">
                    Interior and exterior painting in Southwest Michigan. Clear communication, reliable work, and easy estimates.
                  </p>
                  <div className="flex flex-col sm:flex-row gap-3">
                    <a
                      href="tel:+12695551234"
                      className="bg-[#1A2B4A] text-white px-7 py-3.5 rounded-lg font-bold text-[15px] hover:bg-[#2A3B5A] transition-colors flex items-center justify-center whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-phone-line mr-2 text-lg"></i>
                      Call for Free Estimate
                    </a>
                    <Link
                      to="/projects"
                      className="bg-white border-2 border-[#1A2B4A] text-[#1A2B4A] px-7 py-3.5 rounded-lg font-bold text-[15px] hover:bg-[#1A2B4A] hover:text-white transition-colors flex items-center justify-center whitespace-nowrap cursor-pointer"
                    >
                      View Our Work
                      <i className="ri-arrow-right-line ml-2 text-lg"></i>
                    </Link>
                  </div>
                  <div className="mt-6 pt-6 border-t border-gray-300 flex items-center gap-4">
                    <a href="sms:+12695551234" className="inline-flex items-center text-[#1A2B4A] hover:text-[#C8A96E] font-semibold text-[14px] transition-colors cursor-pointer">
                      <i className="ri-message-3-line mr-2"></i>
                      Prefer to text? Send us a message
                    </a>
                  </div>
                </div>
              </div>
              <div className="hidden lg:block relative h-full min-h-[600px]">
                <img
                  src="https://public.readdy.ai/ai/img_res/3af5186766615b647aa12c8884cb4cf6.jpg"
                  alt="Professional painting service"
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-[#F3F1EE]/30 to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Bar */}
      <section className="bg-[#1A2B4A] py-5">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
            {[
              { icon: 'ri-map-pin-line', label: 'Local to Kalamazoo' },
              { icon: 'ri-image-line', label: 'Real Project Photos' },
              { icon: 'ri-message-3-line', label: 'Call or Text Anytime' },
              { icon: 'ri-translate-2', label: 'Hablamos Español' },
            ].map((item, i) => (
              <div key={i} className="flex items-center justify-center gap-2 text-white/90">
                <i className={`${item.icon} text-[#C8A96E] text-lg`}></i>
                <span className="text-[13px] font-semibold">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Overview Section */}
      <section className="py-16 bg-white">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="text-center mb-10">
            <p className="text-[12px] text-[#C8A96E] uppercase tracking-widest font-bold mb-2">What We Do</p>
            <h2 className="text-[38px] font-extrabold text-[#1A2B4A] mb-3">Painting Services</h2>
            <p className="text-[16px] text-[#6B7280]">We handle all kinds of residential painting projects</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-[#F8F7F5] rounded-xl p-7 hover:bg-[#1A2B4A] group hover:-translate-y-1 transition-all duration-300 cursor-pointer border border-transparent hover:border-[#1A2B4A]"
              >
                <div className="w-12 h-12 bg-[#1A2B4A] group-hover:bg-white/20 rounded-lg flex items-center justify-center mb-4 transition-colors">
                  <i className={`${service.icon} text-2xl text-white group-hover:text-white`}></i>
                </div>
                <h3 className="text-[18px] font-bold text-[#1A2B4A] group-hover:text-white mb-2 transition-colors">{service.title}</h3>
                <p className="text-[14px] text-[#6B7280] group-hover:text-white/80 leading-relaxed mb-4 transition-colors">{service.description}</p>
                <Link
                  to="/services"
                  className="text-[13px] text-[#C8A96E] group-hover:text-[#C8A96E] font-bold inline-flex items-center whitespace-nowrap cursor-pointer"
                >
                  Learn More <i className="ri-arrow-right-line ml-1"></i>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trust + Image Banner */}
      <section className="bg-[#1A2B4A] py-14">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="grid lg:grid-cols-[1fr_auto] gap-10 items-center">
            <div>
              <p className="text-[12px] text-[#C8A96E] uppercase tracking-widest font-bold mb-3">Why Homeowners Choose Us</p>
              <h2 className="text-[32px] font-extrabold text-white mb-8">Simple, Reliable, Local</h2>
              <div className="grid sm:grid-cols-2 gap-5">
                {[
                  { icon: 'ri-map-pin-line', title: 'Local to Kalamazoo', desc: 'We live and work in Southwest Michigan' },
                  { icon: 'ri-image-line', title: 'Real Photos', desc: "See actual projects we've completed" },
                  { icon: 'ri-message-3-line', title: 'Easy to Reach', desc: 'Call or text us anytime' },
                  { icon: 'ri-time-line', title: 'Quick Estimates', desc: 'We respond fast and show up on time' },
                ].map((point, index) => (
                  <div key={index} className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-[#C8A96E]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className={`${point.icon} text-[#C8A96E] text-lg`}></i>
                    </div>
                    <div>
                      <h3 className="text-[15px] font-bold text-white mb-1">{point.title}</h3>
                      <p className="text-[13px] text-white/60">{point.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="hidden lg:block w-[320px] h-[280px] rounded-xl overflow-hidden flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20painter%20carefully%20cutting%20in%20paint%20along%20trim%20with%20brush%2C%20close%20up%20detail%20shot%2C%20quality%20craftsmanship%2C%20residential%20interior%2C%20clean%20work%2C%20simple%20background&width=640&height=560&seq=trust-banner-001&orientation=landscape"
                alt="Quality painting work"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Featured Projects Preview */}
      <section className="py-14 bg-[#F8F7F5]">
        <div className="max-w-[1280px] mx-auto px-6">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-8">
            <div>
              <p className="text-[12px] text-[#C8A96E] uppercase tracking-widest font-bold mb-1">Our Work</p>
              <h2 className="text-[34px] font-extrabold text-[#1A2B4A]">Recent Projects</h2>
              <p className="text-[15px] text-[#6B7280] mt-1">Real work from homes in Southwest Michigan</p>
            </div>
            <Link
              to="/projects"
              className="mt-4 md:mt-0 bg-[#1A2B4A] text-white px-6 py-2.5 rounded-lg font-bold text-[14px] hover:bg-[#2A3B5A] transition-colors whitespace-nowrap cursor-pointer"
            >
              View All Projects
            </Link>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {[
              { src: 'https://readdy.ai/api/search-image?query=freshly%20painted%20modern%20living%20room%20interior%20with%20neutral%20gray%20walls%2C%20clean%20professional%20finish%2C%20natural%20lighting%2C%20residential%20home%2C%20simple%20clean%20background%20showing%20quality%20craftsmanship&width=600&height=800&seq=project-interior-001&orientation=portrait', label: 'Interior Painting • Portage, MI' },
              { src: 'https://readdy.ai/api/search-image?query=beautiful%20freshly%20painted%20house%20exterior%20with%20crisp%20white%20trim%20and%20siding%2C%20professional%20residential%20painting%20work%2C%20clear%20blue%20sky%2C%20well%20maintained%20home%2C%20simple%20clean%20background%20highlighting%20paint%20quality&width=800&height=800&seq=project-exterior-001&orientation=squarish', label: 'Exterior Painting • Kalamazoo, MI' },
              { src: 'https://readdy.ai/api/search-image?query=modern%20kitchen%20with%20beautifully%20refinished%20white%20painted%20cabinets%2C%20professional%20cabinet%20painting%20work%2C%20clean%20finish%2C%20bright%20kitchen%20interior%2C%20simple%20background%20showcasing%20cabinet%20transformation&width=900&height=700&seq=project-cabinet-001&orientation=landscape', label: 'Cabinet Refinishing • Plainwell, MI' },
            ].map((proj, i) => (
              <div key={i} className="relative h-[340px] rounded-xl overflow-hidden group cursor-pointer">
                <img src={proj.src} alt={proj.label} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent">
                  <div className="absolute bottom-5 left-5 text-white">
                    <p className="text-[14px] font-bold">{proj.label}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Areas Section */}
      <section className="py-12 bg-white border-y border-gray-100">
        <div className="max-w-[1100px] mx-auto px-6">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-shrink-0 text-center lg:text-left">
              <p className="text-[12px] text-[#C8A96E] uppercase tracking-widest font-bold mb-1">Where We Work</p>
              <h2 className="text-[28px] font-extrabold text-[#1A2B4A]">Serving Southwest Michigan</h2>
            </div>
            <div className="flex-1 flex flex-wrap justify-center lg:justify-end gap-3">
              {serviceAreas.map((area, index) => (
                <div key={index} className="flex items-center gap-2 bg-[#F3F1EE] px-4 py-2 rounded-full">
                  <i className="ri-map-pin-2-fill text-[#C8A96E] text-sm"></i>
                  <span className="text-[14px] font-semibold text-[#1A2B4A]">{area}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* About Preview Section */}
      <section className="py-14 bg-[#F8F7F5]">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-10 items-center">
            <div className="relative h-[420px] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20Latino%20painter%20in%20work%20clothes%20holding%20paint%20supplies%20and%20tools%2C%20friendly%20smile%2C%20standing%20in%20front%20of%20painted%20house%2C%20trustworthy%20local%20business%20owner%2C%20natural%20outdoor%20lighting%2C%20simple%20clean%20background&width=700&height=900&seq=about-owner-001&orientation=portrait"
                alt="Joel Painting Team"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute bottom-5 left-5 bg-[#1A2B4A] text-white px-4 py-2 rounded-lg">
                <p className="text-[13px] font-bold">Hablamos Español 🇲🇽</p>
              </div>
            </div>
            <div>
              <p className="text-[12px] text-[#C8A96E] uppercase tracking-widest font-bold mb-3">About Us</p>
              <h2 className="text-[30px] font-extrabold text-[#1A2B4A] mb-4">Local Painting Company Serving Your Neighborhood</h2>
              <div className="space-y-4 text-[15px] text-[#6B7280] leading-relaxed">
                <p>We're a local painting company based in the Kalamazoo area. We work with homeowners who want quality painting at a fair price.</p>
                <p>Whether you need a few rooms painted or your whole house done, we take the time to do it right. We show up when we say we will, keep you updated, and clean up when we're finished.</p>
                <p>We speak English and Spanish, so you can talk to us in whichever language is easier for you.</p>
              </div>
              <div className="flex gap-3 mt-6">
                <Link to="/about" className="bg-[#1A2B4A] text-white px-6 py-2.5 rounded-lg font-bold text-[14px] hover:bg-[#2A3B5A] transition-colors whitespace-nowrap cursor-pointer">
                  More About Us
                </Link>
                <Link to="/contact" className="border-2 border-[#1A2B4A] text-[#1A2B4A] px-6 py-2.5 rounded-lg font-bold text-[14px] hover:bg-[#1A2B4A] hover:text-white transition-colors whitespace-nowrap cursor-pointer">
                  Get Estimate
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;
